<template>
  <EdroneModal
    :close-on-esc-key-press="false"
    :close-on-outside-click="false"
    :open="state.isOpen"
    :show-close-icon="false"
    @close="handleCancel"
  >
    <template #title>{{ state.title }}</template>
    <p class="tw:body-2 tw:mb-4 tw:text-default-700" v-html="state.message" />
    <div class="tw:flex tw:gap-2">
      <EdroneButton class="tw:flex-1" type="outline" @click="handleCancel">
        {{ state.cancelText }}
      </EdroneButton>
      <EdroneButton :type="state.type === 'danger' ? 'danger' : 'solid'" class="tw:flex-1" @click="handleConfirm">
        {{ state.confirmText }}
      </EdroneButton>
    </div>
  </EdroneModal>
</template>

<script lang="ts" setup>
import EdroneModal from "edrone-components/EdroneModal.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import { useConfirmDialog } from "./useConfirmDialog.ts";
const { state, handleConfirm, handleCancel } = useConfirmDialog();
</script>
